import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { TierModule } from '../tier/tier.module'
import { HttpClientModule } from '@angular/common/http'
import { MaintenanceRoutingModule } from './maintenance-routing.module'
import { MaintenanceComponent } from './maintenance.component'

@NgModule({
  imports: [
    CommonModule,
    TierModule,
    MaintenanceRoutingModule,
    HttpClientModule,
    MaintenanceComponent,
  ],
})
export class MaintenanceModule {}
